export default "__VITE_ASSET__e3579fff__"